"use client";

import { c as _c } from "react/compiler-runtime";
import { ReactElement, RefObject, useEffect, useState } from "react";
import CommonDropdownItemsMobileWrapper from "./CommonDropdownItemsMobileWrapper";
import { createBreakpoint } from "react-use";
import CommonDropdownItemsDefaultWrapper from "./CommonDropdownItemsDefaultWrapper";
const useBreakpoint = createBreakpoint({
  LG: 1024,
  S: 0
});
export default function CommonDropdownItemsWrapper(t0) {
  const $ = _c(20);
  const {
    isOpen,
    filterLabel,
    buttonRef,
    buttonPosition,
    dynamicPosition: t1,
    setOpen,
    onIsMobile,
    children
  } = t0;
  const dynamicPosition = t1 === undefined ? true : t1;
  const breakpoint = useBreakpoint();
  let t2;
  if ($[0] !== breakpoint) {
    t2 = () => breakpoint !== "LG";
    $[0] = breakpoint;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const getIsMobile = t2;
  const [isMobile, setIsMobile] = useState(false);
  let t3;
  if ($[2] !== getIsMobile) {
    t3 = () => {
      setIsMobile(getIsMobile());
    };
    $[2] = getIsMobile;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== breakpoint) {
    t4 = [breakpoint];
    $[4] = breakpoint;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  useEffect(t3, t4);
  let t5;
  if ($[6] !== isMobile || $[7] !== onIsMobile) {
    t5 = () => {
      onIsMobile(isMobile);
    };
    $[6] = isMobile;
    $[7] = onIsMobile;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== isMobile) {
    t6 = [isMobile];
    $[9] = isMobile;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  useEffect(t5, t6);
  let t7;
  if ($[11] !== buttonPosition || $[12] !== buttonRef || $[13] !== children || $[14] !== dynamicPosition || $[15] !== filterLabel || $[16] !== isMobile || $[17] !== isOpen || $[18] !== setOpen) {
    t7 = <>{isMobile ? <CommonDropdownItemsMobileWrapper isOpen={isOpen} label={filterLabel} setOpen={setOpen}>{children}</CommonDropdownItemsMobileWrapper> : <CommonDropdownItemsDefaultWrapper isOpen={isOpen} setOpen={setOpen} dynamicPosition={dynamicPosition} buttonRef={buttonRef} buttonPosition={buttonPosition}>{children}</CommonDropdownItemsDefaultWrapper>}</>;
    $[11] = buttonPosition;
    $[12] = buttonRef;
    $[13] = children;
    $[14] = dynamicPosition;
    $[15] = filterLabel;
    $[16] = isMobile;
    $[17] = isOpen;
    $[18] = setOpen;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}